import { useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('mhc_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    sessionStorage.setItem('mhc_session_id', sessionId);
  }
  return sessionId;
};

export const usePageTracking = () => {
  const trackedRef = useRef(new Set());

  useEffect(() => {
    const trackPageView = async () => {
      const page = window.location.pathname;
      const pageKey = page + '_' + new Date().toDateString();
      
      // Don't track the same page twice in the same session/day
      if (trackedRef.current.has(pageKey)) {
        return;
      }
      
      trackedRef.current.add(pageKey);
      
      try {
        await axios.post(`${API}/api/site-analytics/track`, {
          page: page,
          referrer: document.referrer || null,
          session_id: getSessionId()
        });
      } catch (error) {
        // Silently fail - don't break the app for analytics
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Small delay to ensure page is loaded
    const timer = setTimeout(trackPageView, 100);
    return () => clearTimeout(timer);
  }, []);
};

export default usePageTracking;
